<!-- 富文本编辑器 输出html模版字符串 -->
<template>
  <quill-editor
    v-if="options"
    ref="myQuillEditor"
    v-model="_value"
    :options="options"
    @blur="onEditorBlur($event)"
    @focus="onEditorFocus($event)"
    @ready="onEditorReady($event)"
    @change="onEditorChange"
  />

  <quill-editor
    v-else
    ref="myQuillEditor"
    v-model="_value"
    @blur="onEditorBlur($event)"
    @focus="onEditorFocus($event)"
    @ready="onEditorReady($event)"
    @change="onEditorChange"
  />
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
export default {
  name: 'EditorItem',
  components: {
    quillEditor
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    options: {
      type: Object,
      default: function() {
        return null
      }
    }
  },
  data() {
    return {
      content: '<h2>I am Example</h2>',
      editorOption: {
        // Some Quill options...
      }
    }
  },
  computed: {
    _value: {
      get() {
        function escapeStringHTML(str) {
          str = str.replace(/&lt;/g, '<')
          str = str.replace(/&gt;/g, '>')
          return str
        }
        // return html2Escape(this.value);
        const content = escapeStringHTML(this.value)
        return content
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    editor() {
      return this.$refs.myQuillEditor.quill
    }
  },
  mounted() {
    console.log('this is current quill instance object', this.editor)
  },
  methods: {
    onEditorBlur(quill) {
      // console.log("editor blur!", quill);
    },
    onEditorFocus(quill) {
      // console.log("editor focus!", quill);
    },
    onEditorReady(quill) {
      // console.log("editor ready!", quill);
    },
    onEditorChange({ quill, html, text }) {
      this._value = html
      this.$emit('change', html)
    }
  }
}
</script>
<style lang='scss' scoped>
.quill-editor {
	overflow: hidden;
	padding-bottom: 65px;
}

::v-deep .ql-toolbar.ql-snow {
  border-color: #DFE3E5;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

::v-deep .ql-container.ql-snow {
  border-color: #DFE3E5;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  .ql-editor {
    min-height: 275px;
  }
}
</style>
